<template>
    <div class="p-8 flex flex-col min-h-[30rem]">
        <p class="text-body-4 font-medium text-default-1">Remove members from group {{props.group.name}}</p>
        <div class="mt-6">
            <p class="text-body-6 text-default-1 mb-1">Select the members</p>
            <ResourceSearchSelect
                    resource-name="members"
                    resource-identifier="uid"
                    :resource-label="(option) => option.first_name + ' ' + option.last_name"
                    :resource-callback="getGroupMembers"
                    :has-error="errors.selectedMembers !== null"
                    @select="handleOnSelectMembers"
            >
            </ResourceSearchSelect>
            <p v-show="errors.selectedMembers !== null" class="text-body-7 font-medium mt-1 text-interactive-3">
                {{ errors.selectedMembers }}
            </p>
        </div>
        <div class="flex flex-row mt-auto">
            <CoreButton
                    buttonType="primary"
                    size="default"
                    class="mr-4"
                    :disabled="!meta.valid"
                    @click="handleOnSubmit"
                    label="Remove from group"
                    :loading="submitButtonLoading"
            />
        </div>
    </div>
</template>

<script setup>
import * as yup from "yup";
import {useField, useForm} from "vee-validate";
import {computed, ref} from "vue";
import CoreButton from "@/components/core/Button.vue";
import ResourceSearchSelect from "../../custom/ResourceSearchSelect.vue";
import {useMembers} from "@/composables/useMembers";
import {useAuth} from "@/stores/AuthStore";

const props = defineProps({
    group: {
        type: Object,
        required: true
    }
})

const emit = defineEmits(['removeMembers']);

const submitButtonLoading = ref(false);

const {organization} = useAuth();
const {getMembers} = useMembers();

const validationSchema = yup.object().shape({
    selectedMembers: yup
        .object({
            include: yup.array().of(yup.string()),
            exclude: yup.array().of(yup.string()),
        })
        .required()
        .label("The members"),
});


const {meta, validate} = useForm({
    initialValues: {
        selectedMembers: {
            include: [],
            exclude: props.group.members.map(member => member.uid),
        },
    },
    validationSchema
});

const selectedMembers = useField("selectedMembers");
const errors = computed(() => {
    return {
        selectedMembers: selectedMembers.errorMessage.value ?? null,
    };
});

function handleOnSelectMembers(members) {
    selectedMembers.value.value = members;
}

async function getGroupMembers(slug, page, perPage, search) {
    return getMembers(slug, page, perPage, search, [props.group.name]);
}

async function handleOnSubmit() {
    validate();

    if (!meta.value.valid || !(selectedMembers.value.value.include && Array.isArray(selectedMembers.value.value.include) && selectedMembers.value.value.include.length > 0)) {
        return;
    }

    submitButtonLoading.value = true;

    emit('removeMembers', selectedMembers.value.value);
}
</script>
